import React from 'react';

export default function GridVerticalBox({ title, src, text }) {
    return <div className="grid-vertical-box">
        <h4 className="grid-vertical-box__title">{title}</h4>
        <embed className="grid-vertical-box__image" src={src} />
        <p className="grid-vertical-box__text">{text}</p>
    </div>
}